<template>
  <v-card class="rounded-lg" outlined>
    <v-card-text class="pa-4">
      <div class="d-flex justify-space-between align-center mb-3">
        <div>
          <span class="text-subtitle-1 font-weight-bold">{{ sub.bank_account.label }}</span>
          <v-chip
            class="ml-2"
            :color="statusColor"
            dark
            x-small
          >
            {{ statusLabel }}
          </v-chip>
        </div>
        <div>
          <v-btn
            v-if="sub.status === 'completed'"
            color="warning"
            x-small
            text
            @click="$emit('reopen', sub)"
          >
            <v-icon x-small left>mdi-lock-open</v-icon>
            ເປີດໃໝ່
          </v-btn>
        </div>
      </div>

      <!-- Upload section -->
      <div v-if="sub.status !== 'completed'" class="mb-3">
        <v-file-input
          v-model="file"
          :label="'ອັບໂຫຼດ ' + sub.bank_account.bank + ' statement'"
          accept=".xlsx,.pdf"
          dense
          hide-details
          outlined
          prepend-icon=""
          prepend-inner-icon="mdi-file-upload"
          :loading="uploading"
        />
        <v-btn
          class="mt-2"
          color="primary"
          small
          depressed
          :loading="uploading"
          :disabled="!file"
          @click="upload"
        >
          <v-icon small left>mdi-upload</v-icon>
          ອັບໂຫຼດ
        </v-btn>
      </div>

      <!-- Summary stats -->
      <div v-if="sub.statement_file">
        <div class="text-caption grey--text mb-1">
          {{ sub.statement_file }} ({{ sub.total_rows }} ແຖວ)
        </div>
        <v-row dense>
          <v-col cols="4">
            <div class="text-caption grey--text">ກົງກັນ</div>
            <div class="text-body-1 font-weight-bold green--text">{{ sub.matched_count }}</div>
          </v-col>
          <v-col cols="4">
            <div class="text-caption grey--text">ລໍຖ້າ</div>
            <div class="text-body-1 font-weight-bold" :class="sub.pending_count > 0 ? 'orange--text' : 'green--text'">{{ sub.pending_count }}</div>
          </v-col>
          <v-col cols="4">
            <div class="text-caption grey--text">ຍອດລວມ</div>
            <div class="text-body-2 font-weight-bold">{{ formatCurrency(sub.total_statement_amount) }}</div>
          </v-col>
        </v-row>

        <!-- Actions -->
        <div class="mt-3 d-flex">
          <v-btn
            v-if="sub.status !== 'completed'"
            color="primary"
            small
            text
            @click="$emit('view-detail', sub)"
          >
            <v-icon small left>mdi-eye</v-icon>
            ເບິ່ງລາຍລະອຽດ
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="sub.status === 'in_progress'"
            color="success"
            small
            depressed
            @click="$emit('complete', sub)"
          >
            <v-icon small left>mdi-check</v-icon>
            ສຳເລັດ
          </v-btn>
        </div>
      </div>

      <!-- No file yet -->
      <div v-else class="text-caption grey--text text-center pa-4">
        ຍັງບໍ່ມີ statement ອັບໂຫຼດ
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SubReconciliationCard',
  props: {
    sub: { type: Object, required: true },
    batchId: { type: String, required: true },
  },
  data() {
    return {
      file: null,
      uploading: false,
    };
  },
  computed: {
    statusColor() {
      switch (this.sub.status) {
        case 'completed': return 'green';
        case 'in_progress': return 'blue';
        default: return 'grey';
      }
    },
    statusLabel() {
      switch (this.sub.status) {
        case 'completed': return 'ສຳເລັດ';
        case 'in_progress': return 'ກຳລັງດຳເນີນ';
        default: return 'ລໍຖ້າ';
      }
    },
  },
  methods: {
    async upload() {
      this.uploading = true;
      try {
        const formData = new FormData();
        formData.append('file', this.file);
        const res = await this.$axios.post(
          `ldb-reconciliation/${this.batchId}/sub-reconciliations/${this.sub.id}/upload`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 600000 },
        );
        this.$emit('uploaded', res.data.data);
        this.file = null;
        this.$store.commit('Toast_State', { value: true, color: 'success', msg: 'ອັບໂຫຼດສຳເລັດ' });
        // e.g. the short (6-column) LDB export: in-app payments have no phone or customer
        const warnings = (res.data.data && res.data.data.warnings) || [];
        if (warnings.length) {
          // eslint-disable-next-line no-alert
          alert(`ກະລຸນາກວດ:\n\n${warnings.join('\n\n')}\n\n(ໃຫ້ອັບໂຫຼດ "ລາຍງານບັນຊີແບບລະອຽດ" 9 ຖັນ ຈາກ LDB Biz)`);
        }
      } catch (e) {
        console.error(e);
        const msg = e.response?.data?.message || 'ອັບໂຫຼດລົ້ມເຫຼວ';
        this.$store.commit('Toast_State', { value: true, color: 'error', msg });
      } finally {
        this.uploading = false;
      }
    },
    formatCurrency(val) {
      if (!val) return '0';
      return Number(val).toLocaleString('en-US');
    },
  },
};
</script>
